<template>
  <v-expansion-panel @click.native.stop>
    <v-expansion-panel-header>Custom Offer</v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-row>
        <v-col cols="12">
          <v-form ref="offerSummaryForm">
            <v-text-field v-model="offer_summary" outlined label="Offer Summary" @blur="handleSave()" @keydown.enter="$event.target.blur()" />
          </v-form>
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'OfferSummaryPanel',

  props: {
    offerSummary: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    offer_summary: null,
  }),

  watch: {
    offerSummary: function () {
      this.offer_summary = this.offerSummary
    },
  },

  mounted: function () {
    this.offer_summary = this.offerSummary
  },

  methods: {
    handleSave() {
      this.$emit('save', { offer_summary: this.offer_summary })
    },
  },
})
</script>
